import React from 'react'
type Props = {
    size?: number,
    color?: string,
    strokeWidth?: number,
    style?: React.CSSProperties,
    onClick?: React.MouseEventHandler<SVGSVGElement>,
}
function RefreshEdgeIcon({size=20, color="#17B2EB", strokeWidth=1.4, style, onClick}: Props) {
  return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} style={style}>
<rect width="24" height="24" rx="8" fill="#0B4A62"/>
<g clip-path="url(#clip0_11431_341154)">
<path d="M18.6663 11.1666C18.4625 9.7001 17.7822 8.3413 16.7302 7.2995C15.6782 6.25769 14.3128 5.59068 12.8444 5.40121C11.376 5.21174 9.88602 5.51032 8.60401 6.25096C7.32199 6.99159 6.31905 8.1332 5.74967 9.49992M5.33301 6.16658V9.49992H8.66634" stroke="#17B2EB" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.33301 12.833C5.53681 14.2995 6.21712 15.6583 7.26914 16.7001C8.32117 17.7419 9.68654 18.4089 11.1549 18.5984C12.6234 18.7879 14.1133 18.4893 15.3953 17.7486C16.6774 17.008 17.6803 15.8664 18.2497 14.4997M18.6663 17.833V14.4997H15.333" stroke="#17B2EB" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.6865 12.0003C10.6865 12.3539 10.827 12.6931 11.077 12.9431C11.3271 13.1932 11.6662 13.3337 12.0199 13.3337C12.3735 13.3337 12.7126 13.1932 12.9627 12.9431C13.2127 12.6931 13.3532 12.3539 13.3532 12.0003C13.3532 11.6467 13.2127 11.3076 12.9627 11.0575C12.7126 10.8075 12.3735 10.667 12.0199 10.667C11.6662 10.667 11.3271 10.8075 11.077 11.0575C10.827 11.3076 10.6865 11.6467 10.6865 12.0003Z" stroke="#17B2EB" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.0195 9.66699V10.667" stroke="#17B2EB" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.0195 13.334V14.334" stroke="#17B2EB" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.0418 10.834L13.1758 11.334" stroke="#17B2EB" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.8667 12.667L10 13.167" stroke="#17B2EB" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 10.834L10.8667 11.334" stroke="#17B2EB" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.1758 12.667L14.0424 13.167" stroke="#17B2EB" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_11431_341154">
<rect width="20" height="20" fill="white" transform="translate(2 2)"/>
</clipPath>
</defs>
</svg>
  )
}

export default RefreshEdgeIcon